export const lightTheme = {
  nav: "#FAFAFA",
  background: "#ffffff",
  cardTransparent: "rgba(255, 255, 255, 0.04)",
  text: "#000",
  subtext: "#DDDF22",
  primary: "#F7F7F7",
  secondary: "#F7F7F7",
  tertiary: "#E2E1E2",
  iconPadd: "#E2E1E2",
  content: "#E4E4E7",
  faqContent : "#FFFFFF",
  vault: "#FFFFFF",
  border: "#CCCBCD",
  borderCard: "#DDDF22",
  buttonText: "#fff",
  buttonBorder: "#fff",
  heading: "#fff",
  section: "#F7F7F7",
};

export const darkTheme = {
  nav: "#141414",
  background: "#141414",
  cardTransparent: "rgba(255, 255, 255, 0.04)",
  text: "#fff",
  subtext: "#DDDF22",
  primary: "#000",
  secondary: "#242424",
  tertiary: "#141414",
  iconPadd: "#333333",
  content: "#333333",
  faqContent : "#242424",
  vault: "#333333",
  border: "#141414",
  borderCard: "#DDDF22",
  buttonText: "#000",
  buttonBorder: "#fff",
  heading: "#141414",
  section: "#1D1D1D",
};
